import React from 'react';

const SearchBar = ({ searchQuery, handleSearchChange, handleSearchSubmit, searchInputRef }) => {
    return (
        <form onSubmit={handleSearchSubmit} className="flex justify-center mb-10">
            <div className="w-full max-w-xl flex items-center bg-[#141414] shadow-md">
                <input
                    type="text"
                    placeholder="Search for movies..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    ref={searchInputRef}
                    className="w-full py-4 px-6 bg-transparent text-lg text-white placeholder-gray-400 focus:outline-none"
                />
                <button
                    type="submit"
                    className="ml-2 flex items-center justify-center bg-[#e50914] hover:bg-[#b0060f] text-white font-bold py-3 px-6 transition duration-200 shadow focus:outline-none"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
                    </svg>
                    Search
                </button>
            </div>
        </form>
    );
};

export default SearchBar;
